import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Card from '@material-ui/core/Card';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import { Collapse, Container, IconButton } from '@material-ui/core';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import clsx from 'clsx';
import useNotificationDialog from '../../shared/components/useNotificationDialog';
import { Fragment } from 'react';
import {Alert} from '@material-ui/lab'



const useStyles = makeStyles({
  root: {
    maxWidth: 350,
  },
  media: {
    height: 140,
  },
  title : {
      color:'orange',
      fontWeight: 'bold',
      fontSize:14,
      padding:0
    }
});

export default function ReceivingCard({titile, content, collapse, actionName, action,
                                         haveCollapse, action2, action2Name=null, isLoading}) {
  const classes = useStyles();
  const [expanded, setExpanded] = React.useState(false);
  const {open, ShowNotificationDialog, handleClose, handleOpen} = useNotificationDialog()


  const handleExpandClick = () => {
    setExpanded(!expanded);
  };


  const customClic=()=>{
     if(action2Name === "Fermer"){
        handleOpen()
     }
     if(action2Name === "Details"){
       action2()
       
     }
  }


  

  return (
    <Card className={classes.root} elevation={3}>
        {
            open && <ShowNotificationDialog title="Fermer le reception"
                action={
                    <Fragment>
                    <Button color="primary" onClick={handleClose} > annuler </Button>

                    <Button onClick={()=>{action2(); handleClose()} } color="secondary"> 
                        {action2Name}
                    </Button>
                </Fragment>
                }>
                <Alert severity="error"> Vous êtes sur le point des fermer cette reception </Alert>
            </ShowNotificationDialog>
        }
        <CardContent>
            <Container className={classes.title}>
                <Typography gutterBottom variant="inherit" component="h6">
                    {titile}
                </Typography>
            </Container>

            {content}

            <Collapse in={expanded} timeout="auto" unmountOnExit>
                <br />
                {collapse}
            </Collapse>
        </CardContent>

      <CardActions style={{justifyContent: 'space-between'}}>

     { haveCollapse && <IconButton
          className={clsx(classes.expand, {
            [classes.expandOpen]: expanded,
          })}
          onClick={handleExpandClick}
          aria-expanded={expanded}
          aria-label="show more"
          size="small"
        >
          <ExpandMoreIcon />
        </IconButton> }


          {action2Name && 
          <Button disabled={isLoading} color="secondary" onClick={customClic}>
            {action2Name && action2Name}
        </Button> }
        
        <Button size="small" color="primary" onClick={action}>
          {actionName}
        </Button>
      </CardActions>
    </Card>
  );
}
